import { Reveal, SectionHeading } from "../components/Reveal";

export default function ChiSiamoSection() {
  return (
    <section id="chi-siamo" className="section" data-testid="chi-siamo-section">
      <div className="container-hub">
        <div className="max-w-[760px]">
          <SectionHeading
            eyebrow="La visione"
            title={<>CHI C'È DIETRO <span className="gold-text">A.C. HUB.</span></>}
          />
          <Reveal delay={0.15}>
            <p className="lead mt-7" data-testid="founder-copy">
              Fondato da <strong className="font-semibold text-cream">Alessio Cannino</strong>,
              investitore e consulente immobiliare privato, con un'impresa edile di famiglia attiva da oltre
              trent'anni. Due mondi che raramente si parlano — consulenza e cantiere — qui lavorano insieme, sotto
              la stessa direzione.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-9 border-l-2 border-gold pl-6 font-serif text-[24px] leading-snug text-cream sm:text-[28px]" data-testid="founder-quote">
              «Non devi coordinare il mondo immobiliare. Lo facciamo noi.»
            </p>
            <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.24em] text-gold-light" data-testid="founder-signature">
              Alessio Cannino — Fondatore & Direzione
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
